import { Component, DestroyRef, effect, inject, input } from '@angular/core';

import { LangPipe } from '@reforgium/presentia';
import { SkButtonComponent } from '@ss/ui';

import { DocumentService } from 'use-cases/document.service';
import { RedactorService } from 'features/redactor';

@Component({
  selector: 'app-export-action',
  template: `
    <div class="flex justify-between gap-4 print:hidden">
      <sk-button appearance="primary" size="small" [label]="'common.actions.print' | lang" (clicked)="handlePrint()" />
    </div>
  `,
  styles: `
    sk-button {
      font-size: var(--app-button-font-size);
    }
  `,
  imports: [SkButtonComponent, LangPipe],
})
export class ExportAction {
  versionId = input<number | undefined>();

  redactor = inject(RedactorService);
  documentService = inject(DocumentService);

  constructor() {
    effect(() => {
      const versionId = this.versionId();

      if (!versionId) {
        return;
      }
    });

    inject(DestroyRef).onDestroy(() => {
      this.redactor.dispose();
      this.documentService.files.abortAll();
    });
  }

  handlePrint() {
    this.redactor.print();
  }
}
